// extracted by mini-css-extract-plugin
export default {"top-box":"AllowAccess_top-box__yfXzm","li-box":"AllowAccess_li-box__yEKSC","bottom-box":"AllowAccess_bottom-box__U6y9J"};